import dynamic from 'next/dynamic';
import { RoomRequestsProps } from './RoomRequests.types';
import { RoomRequestsProps as RoomRequestsV2Props } from './V2/RoomRequests.types';

export const RoomRequestsMGP = dynamic<RoomRequestsProps & Partial<RoomRequestsV2Props>>(() =>
  import('./RoomRequestWrapper').then(module => module.RoomRequests)
);
